import React from 'react'
import { TExtraField, TExtraFieldValue } from '../../../../models/ExtraField'
import { dynamicCatalogService } from '../../../../services/DynamicCatalogService'
import { Cascader, Form } from 'antd'

interface Props {
  idx: number
  fieldConfig: TExtraField
  fieldValue: TExtraFieldValue
}

export const ExtraFieldFormValuesCatalog = ({ idx, fieldConfig, fieldValue }: Props) => {
  const [loading, setLoading] = React.useState(false)
  const [options, setOptions] = React.useState<TOption[]>([
    { value: `${fieldValue.value}`, label: '' } // loading state
  ])

  React.useEffect(() => {
    if (fieldConfig.catalogId) {
      setLoading(true)
      dynamicCatalogService.getItemsOptions(fieldConfig.catalogId)
        .then(setOptions)
        .catch(window.logger.error)
        .finally(() => setLoading(false))
    } else {
      setOptions([])
    }
  }, [fieldConfig])

  return (
    <Form.Item
      key={fieldConfig.id}
      label={fieldConfig.name}
      name={['fields', idx, 'value']}
      rules={fieldConfig.required ? [{ required: true }] : []}
      extra={fieldConfig.extraId}
    >
      <Cascader
        multiple={fieldConfig.multiSelect}
        loading={loading}
        options={options}
      />
    </Form.Item>
  )
}
